import * as Sentry from '@sentry/vue'

import { isProduction, maEnv } from '@/lib/env'

export function initSentry(app, router) {
  if (!isProduction)
    return

  const release = maEnv.VITE_APP_SENTRY_RELEASE
  if (!release) {
    console.warn('Sentry | VITE_APP_SENTRY_RELEASE is not defined! Sentry will not be initialized.')
    return
  }

  Sentry.init({
    app,
    release,
    environment: maEnv.NODE_ENV,
    dsn: maEnv.VITE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Defines which request URLs the Sentry tracing headers should be attached to; only requests with URLs matching the specified patterns will include tracing information.
    tracePropagationTargets: [
      /^http:\/\/localhost:4000/,
      /^http:\/\/localhost:4173/,
      /^https:\/\/gateway.mobileaction\.co/,
      /^https:\/\/gateway-testing.mobileaction\.co/,
      /^https:\/\/mobileaction-duv-.*\.herokuapp\.co/,
    ],
  })

  // eslint-disable-next-line no-console
  console.info('Sentry | initialized! version: ', release)
}
